<template>

    <templateList
        page-name="Lista de Clientes"
        search-event="sales-deals-search"
        add-event="sales-deals-add"
        filters-apply-event="filter-list-deals"
        add-button-text="Cadastrar Cliente"
        clear-filters-event="clear-filters-list-deals"
        search-input-placeholder="Buscar cliente"
        menu-card-icon="fal fa-cog"
        @input='loadFilters'
    >

        <template #bradcrumbs>
            <ui-breadcrumbs design="full" :container="false">
                <template #left>
                    Vendas &#8226; Clientes
                </template>
            </ui-breadcrumbs>
        </template>

        <template #viewOptions>
            <div v-if="(hasPermissionToChangeStageInBulk || hasPermissionToChangeOwnerInBulk) && totalItens > 0"  class="selected-checkbox">
                <span class="selected-checkbox-text">
                    Você selecionou <span class="selected-checkbox-count">{{ totalItens }}</span> {{ totalItens > 1 ? 'clientes' : 'cliente'}}.
                </span>
                <div class="select-container">
                    <ui-select-v2
                        v-model="valueSelect"
                        :data="selectMassAction"
                        return-value="valueSelect"
                        :placeholder="'Selecione uma ação'"
                        :search="false"
                        :show-footer="false"
                        size="lg"
                        :margin-botton="false"
                        @input="openBulkModal"
                    />
                </div>
            </div>
        </template>

        <!-- <template #viewOptions>
            <span class="text-label">Exibir como:</span>
            <div class="type-group">
                <span>
                    <button class="type-button active" type="button">
                        <i class="fal fa-list"/>
                        Lista
                    </button>
                    <button class="type-button" type="button" @click="showFunnel">
                        <i class="fal fa-table"/>
                        Funil
                    </button>
                </span>
            </div>
        </template> -->

        <template #content>
            <ui-data-table
                :per-page="50"
                :columns="tableColumnsComputed"
                :filters="tableFiltersComputed"
                :sort-by="{ value: 'updated_at', dir: 'desc' }"
                :control-fixed="true"
                :is-fixed-list="true"
                :borders="true"
                :show-checkbox-table="hasPermissionToChangeStageInBulk || hasPermissionToChangeOwnerInBulk"
                :zebra="true"
                name="salesDealsList"
                service="deal"
                search-event="sales-deals-search"
                tr-component="sales/deals/table-line"
                not-found-icon="fal fa-user"
                not-found-text="Não foi possível encontrar nenhum Cliente"
                :is-permission-to-change-state="hasPermissionToChangeStageInBulk || hasPermissionToChangeOwnerInBulk"
                @checked-itens="handleCheckedItens"
            />

            <ui-broker-modal name="sales-deals-select-broker" />

            <ui-deal-stage-status-modal name="sales-deals-select-stage-status" success-event="modal-result-list-move-to-status"/>
            <ui-procedure-modal name="deal-multiple-precedure" success-event="sales-deals-search" />
            <ui-deal-create-historical-modal name="sales-deals-select-create-historical" />
            <change-stage-status-modal-bulk
                name="change-stage-status-modal-bulk"
                :deals="checkedItens"
                @bulk-step-data="onBulkStepDataReceived"
            />
            <bulk-change-stage-step
                name="bulk-step-modal"
                :deals="checkedItens"
                :stage="bulkStage"
                :status="bulkStatus"
                @close-bulk-step="onBulkStepClosed"
            />
            <change-responsible-modal-bulk
                name="change-responsible-modal-bulk"
                :deals="checkedItens"
                @bulk-step-data="onBulkResponsibleStepDataReceived"
            />
            <bulk-change-responsible-step
                name="bulk-responsible-step-modal"
                :deals="checkedItens"
                :responsible="bulkResponsible"
                @close-bulk-step="onBulkStepClosed"
            />
        </template>
        <template #filters>
            <form>
                <template v-for="(filter, index) in filters">
                    <ui-date-range
                        v-if="filter.component === 'datepicker-range' && !filter.hidden"
                        :key="index"
                        v-model="filter.params.value"
                        :label="filter.label"
                        :disabled="filter.disabled"
                        list-type="normal"
                        size="md" />

                    <ui-select-v2
                        v-else-if="filter.component === 'select-tags' && !filter.hidden"
                        :key="index"
                        v-model="filter.params.value"
                        :ajax-search="filter.ajaxSearch"
                        :data="filter.options"
                        :label="filter.label"
                        :search-event="filter.searchEvent"
                        :item-label="filter.itemLabel"
                        :search="filter.searchAble"
                        :multiple="filter.multiple"
                        :return-value="filter.returnValue || 'object'"
                        :group-by="filter.groupBy || ''"
                        :loading="filter.loading"
                        :open-event="filter.openEvent"
                        :disabled="filter.disabled"
                        :show-button-apply-button="false"
                        size="md"
                        @input="call(filter.handler, $event)" />
                </template>
            </form>
        </template>
    </templateList>
</template>

<script>
import { uiBreadcrumbs, uiDataTable } from "@/components/ui"
import { uiSelectV2, uiDateRange } from "@/components/ui/form"
import {
    uiBrokerModal,
    uiDealCreateHistoricalModal,
    uiDealStageStatusModal
} from '@/components/ui-facilita/modals'
import uiProcedureModal from '@/components/ui-facilita/sales/procedure-modal'
import changeStageStatusModalBulk from '@/components/ui-facilita/change-stage-status-modal-bulk'
import changeResponsibleModalBulk from '@/components/ui-facilita/change-responsible-modal-bulk'
import BulkChangeStageStep from '@/components/ui-facilita/change-stage-status-modal-bulk/bulk-change-stage-step'
import BulkChangeResponsibleStep from '@/components/ui-facilita/change-responsible-modal-bulk/bulk-responsible-step'

import templateList from "@/templates/page-list"

import helpers from '@/mixins/helpers'

import { funnel, groups, team } from '@/services/axios'
import { storage } from "@/services/storage"

import { mapGetters, mapActions } from 'vuex'

import { filters, columns } from './data'

export default {
    name: 'sales-deals-list',
    components: {
        templateList,
        uiBreadcrumbs,
        uiDataTable,
        uiBrokerModal,
        uiDealStageStatusModal,
        uiDealCreateHistoricalModal,
        uiDateRange,
        uiProcedureModal,
        uiSelectV2,
        changeStageStatusModalBulk,
        BulkChangeStageStep,
        changeResponsibleModalBulk,
        BulkChangeResponsibleStep
    },

    mixins: [helpers],

    data() {
        return {
            layout: {
                showFiltersMenu: false,
            },
            configurations: {
                manager: {
                    label: storage.get('label_manager')
                },
                broker: {
                    label: storage.get('label_broker')
                }
            },
            filters: [...filters],
            tableColumns: [...columns],
            hasStatus: true,
            channels: {
                page: 1,
                perPage: 1000,
                totalPage: 1
            },
            /*
            * Per page estará com a quantidade de 1000 até
            * adicionar uma busca no select2 que trabalhe
            * com dados já carregado, hj o tipo que existe
            * pede para  adicionar pelo menos duas caracters
            * para trazer o os dados via pesquisa, assim que
            * criar um novo o perpage deve trazer somente 20
            * e a busca deve ser pela requisição.
            */
            channelPrimaryLoad: false,

            /**
             * Variáveis para alterações em massa
             */
            checkedItens: [],
            totalItens: 0,
            valueSelect: null,
            selectMassAction: [],
            hasGroupPermissionToChangeOwner: false,
            bulkStage: { id: null, name: '' },
            bulkStatus: { id: null, name: '' },
            bulkResponsible: { id: null, name: '' }
        }
    },

    computed: {
        ...mapGetters('auth', {
            user: 'getUser'
        }),
        /**
         * Computed property que retorna os dados dos filtros a serem passados
         * para o datatable
         */
        tableFiltersComputed() {
            const namesWithPrefixSuffix = ['origin_id', 'product_id', 'funnel_stage_status_id'];
            const filtersToUpdate = ['tags', 'deal_channel'];

            return this.filters.map(filter => {
                let params = { ...filter.params };
        
            if (namesWithPrefixSuffix.includes(filter.params.name)) {
                params.value = this.filterMaker(filter.params.value, '^', '$');
            } else if (filtersToUpdate.includes(filter.params.name)) {
                params.value = this.filterMaker(filter.params.value);
            } else if (filter.params.name === 'tasks') {
                const initialValue  = filter.params.value;
                const handleValue = (val) => {
                    return val === 3 ? 0 : val
                }  
                const computedValue = (initialValue  === 2) ? '' : handleValue(initialValue)
                params.value = computedValue;
            } else if (filter.params.name === 'reserves') {
                const filterValue  = filter.params.value;
                const handleValue = (val) => {
                    switch(val) {
                        case 2:
                            return '0'
                        case 1:
                            return "1"
                        case 3: 
                            return ""
                    }
                }  
                const computedValue =  handleValue(filterValue)
                params.value = computedValue;
            }

            return params;

            })
        },

        /**
         * Computed property que retorna as colunas ativas
        */
        tableColumnsComputed() {
            return this.tableColumns.filter(column => {
                if (!column.allowedExcept.includes(this.user.user_group)) return column
            })
        },
        hasPermissionToChangeStageInBulk() {
            const user = JSON.parse(localStorage.getItem('fac_user_logged') || '{}')
            return (
                user?.config_permissions?.userPrivilegedMoveDeal === 1 &&
                user?.config_permissions?.bulkActionMoveDeal === 1
            )
        },

        hasPermissionToChangeOwnerInBulk() {
            const user = JSON.parse(localStorage.getItem('fac_user_logged') || '{}')
            const perms = user?.config_permissions ?? {}
            return perms.bulkActionChangeDealOwner === 1 && this.hasGroupPermissionToChangeOwner
        }
    },

    watch: {
        hasPermissionToChangeOwnerInBulk(newVal) {
            if (newVal) {
              const alreadyExists = this.selectMassAction
                .some(action => action.valueSelect === 'alteração-de-responsável')
            
              if (!alreadyExists) {
                this.selectMassAction.push({
                  label: 'Alteração de Responsável',
                  valueSelect: 'alteração-de-responsável'
                })
              }
            } else {
              this.selectMassAction = this.selectMassAction
                .filter(action => action.valueSelect !== 'alteração-de-responsável')
            }
        }
    },

    async mounted() {
        this.fetchUsersWithPermissions()
        this.buildSelectMassAction()
        
        //muda a etapa/status do produto
        this.$root.$on('modal-result-list-move-to-status', async value => {
            let body = value && value.new && value.new.funnel_stage_id ? { funnel_stage_id: value.new.funnel_stage_id } : null
            let id = value && value.new && value.new.id ? value.new.id : null
            if (body && id) {
                if(value.new.funnel_stage_status_id && value.new.funnel_stage_status_id != '') {
                    body['funnel_stage_status_id'] = value.new.funnel_stage_status_id
                }

                const { data } = await funnel.updateV2('deal/', `${id}/move`, body)

                if (data.msg && data.status !== 'success') {
                    return this.$root.$emit('close-modal-animation', false, data.msg)
                } else {
                    await this.$root.$emit("datatable-reload-salesDealsList")
                    this.$root.$emit('close-modal-animation', true, 'Atualizado com successo!')
                }
            }
        })

        /** Redireciona para o guia de cadastro de negócios/clientes do painel Legado */
        this.$root.$on('sales-deals-add', () => {
            /**
             * Emite o evento do Google Analytics
             */
            this.$gtm.trackEvent({
                event: "fac_button_click",
                category: "vuejs-criar cliente",
                action: "click",
                label: "Criar cliente a partir da lista de clientes",
            })

			this.$root.$emit('modal-open-create-deal-modal')
            this.$root.$emit('create-proposal-modal', false)
        })

        /** Realiza uma listagem aplicando os filtros necessários */
        this.$root.$on('filter-list-deals', () => {
            this.$root.$emit('sales-deals-search')
        })

        /** Trata o evento que limpa os filtros e refaz a listagem */
        this.$root.$on('clear-filters-list-deals', async () => {
            await this.resetFilters()
            this.$root.$emit('clear-all-dates')
            this.$root.$emit('sales-deals-search', '', this.filters)
        })
        this.$root.$on('select-v2-open-event-list-filter-users-sdr', () => {
            this.requisitionFiltersChagerd('Usuários')
        })

        this.$root.$on('select-v2-ajax-search-list-search-users-sdr', async (search) => {
            await this.requisitionFiltersPagination('Usuários', search)
        })

		this.$root.$on('select-v2-open-event-deals-list-tags', async () => {
            await this.requisitionFiltersChagerd('Tags')
		})

        this.$root.$on('select-v2-ajax-search-channel-next-event', async () => {
            //adiciona mais uma requisição para o scrool
            if(this.channels.page > this.channels.totalPage) return

            await this.requisitionFiltersChagerd('Canal', `?per_page=${this.channels.perPage}&page=${this.channels.page}`)
        })

        this.$root.$on('select-v2-open-event-kanban-filter-channel', async () => {
            if(!this.channelPrimaryLoad) {
                this.channelPrimaryLoad = true
                await this.requisitionFiltersChagerd('Canal', `?per_page=${this.channels.perPage}&page=${this.channels.page}`)
            }
        })
    },


    beforeDestroy() {
        this.resetFilters()
        this.$root.$off('sales-deals-add')
        this.$root.$off('filter-list-deals')
        this.$root.$off('clear-filters-list-deals')
		this.$root.$off('select-v2-open-event-deals-list-tags')
		this.$root.$off('modal-result-list-move-to-status')
		this.$root.$off('select-v2-open-event-list-filter-users-sdr')
		this.$root.$off('select-v2-ajax-search-list-search-users-sdr')
        this.$root.$off('select-v2-ajax-search-channel-next-event')
        this.$root.$off('select-v2-open-event-kanban-filter-channel')
    },


    methods: {
        ...mapActions('dataTable', [
            'setIdleRules'
        ]),
        /**
         * Chama dinamicamente um handler para tratar o evento do filtro
         */
        call(handler, event) {
            if (handler) this[handler](event)
        },
        /**
         * Reseta os filtros
         */
        resetFilters() {
            for (const filter of this.filters) {
                if (filter.component === 'select-tags') {
                    filter.params.value = null
                    if (filter.handler) this.call(filter.handler, null)
                }

                if (filter.component === 'datepicker-range'){
                    filter.params.value = ''
                }
            }
        },
        loadFilters(filters) {
            if (filters) this.filters.map(res => {
                res.params = filters.find(({ name }) => name == res.params.name)
            })
           
            for (const filter of this.filters) {
                if(filter.params.name) {
                    switch (filter.params.name) {
                        case 'team_id':
                            /**
                             * Caso o usuário logado seja do tipo gerente ou corretor, seleciona a equipe deste
                             * e desabilita o filtro de equipes
                             */
                            if (['manager', 'broker'].includes(this.user.user_group)) {
                                if (this.user.user_group === 'manager') {
                                    filter.params.value = this.user.team ? this.user.team.id : null
                                }

                                filter.disabled = true
                                filter.hidden = true
                            }
                            break

                        case 'manager_id':
                            filter.label = this.configurations.manager.label

                            /**
                             * Caso o usuário logado seja do tipo gerente ou corretor, carrega o manager_id deste
                             * e desabilita o filtro de gerentes
                             */
                            if (['manager', 'broker'].includes(this.user.user_group)) {
                                if (this.user.user_group === 'manager') {
                                    filter.params.value = this.user.manager_id || null
                                }

                                filter.disabled = true
                                filter.hidden = true
                            }
                            break

                        case 'broker_id':
                            filter.label = this.configurations.broker.label

                            if (this.user.user_group === 'broker') {
                                filter.disabled = true
                                filter.hidden = true
                            }
                            break

                        case 'reserves': {
                            let value = filter?.params?.value ?? null
                            if (value === '0')      value = 2
                            else if (value === '1') value = 1
                            else if (value === '')  value = 3

                            filter.params.value = value
                            break
                        }

                        case 'tasks': {
                            let value = filter?.params?.value ?? null 
                            if (value === '')       value = 2
                            else if (value === '0') value = 3

                            filter.params.value = value
                            break
                        }

                        case 'owner':
                            if (this.user.user_group === 'broker') {
                                filter.disabled = true
                                filter.hidden = true
                            }
                            break
                    }
                }

                /** Verifica se o filtro possui um handler e se seu valor já foi definido no pré-processamento */
                if (filter.handler && filter.params.value) this.call(filter.handler, filter.params.value)

                if (filter.service && filter.requestOnStart && !filter.alreadyRequested) {
                    (() => import('@/services/axios/modules/'+ filter.service + '.js'))().then(service => {
                        const api = service.default.build()
                        let params = ['']
                        if (filter.serviceParams) params = [...filter.serviceParams]

                        api[filter.method](...params).then(response => {
                            let data = []
                            /** Verifica se a requisição retornou uma paginação */
                            // eslint-disable-next-line no-prototype-builtins
                            if (response.data.hasOwnProperty('total')) {
                                data = [...response.data.data]

                            /** Verifica se a requisição retornou um array */
                            // eslint-disable-next-line no-prototype-builtins
                            } else if (response.data.hasOwnProperty('length')) {
                                data = [...response.data]

                            /** Se nenhum dos outros casos for atendido, trata o retorno como um objeto */
                            } else if (typeof response.data === 'object') {
                                if (response.data.data) {
                                    data = [...response.data.data]

                                } else {
                                    data = { ...response.data }
                                }
                            }

                            /** Verifica se os resultados necessitam ser formatados */
                            if (filter.parse) {
                                filter.options = filter.parse(data)
                                /**
                                 * Seta todas as regras de ociosidades no Vuex para serem utilizadas
                                 * pelo datatable
                                 */
                                if (filter.params.name === 'idle_color_v2') this.setIdleRules(data)

                            } else {
                                filter.options = Object.values(data)
                            }
                        })

                        filter.alreadyRequested = true
                    }).catch(this.handleApiError)
                }
            }
            this.hasStatus = false
        },
        /**
         * Handler para tratar o evento de quando uma etapa for selecionada, de modo
         * a carregar os status desta etapa
         */
        funnelStageHandler(value) {
            const index = this.filters.findIndex(filter => filter.params.name === 'funnel_stage_status_id')
            
            if(!this.hasStatus) {
                this.filters[index].options = []
                this.filters[index].params.value = []
            }
            if (value) {
                funnel.getStatusByStage(value)
                    .then(response => {
                        this.filters[index].options = response.data
                    })
                    .catch(this.handleApiError)
            }
        },
        /**
         * Handler para tratar o evento de quando uma equipe for selecionada, de modo
         * a carregar os gerentes desta equipe
         */
        teamHandler(value) {
            const manager = this.filters.findIndex(filter => filter.params.name === 'manager_id')
            this.filters[manager].options = []
            this.filters[manager].params.value = null

            const broker = this.filters.findIndex(filter => filter.params.name === 'broker_id')
            this.filters[broker].options = []
            this.filters[broker].params.value = null

            /** Check if the event value is valid */
            const isValid = value && (typeof value === 'object' ? value.length : true)

            if (isValid) {
                team.getManagersByTeam(value)
                    .then(response => {
                        const index = this.filters.findIndex(filter => filter.params.name === 'manager_id')
                        this.filters[index].options = response.data
                        if (this.user.user_group === 'manager') {
                            this.call(this.filters[index].handler, this.filters[index].params.value)
                        }
                    })
                    .catch(this.handleApiError)
            }
        },
        /**
         * Handler para tratar o evento de quando um gerente for selecionado, de modo
         * a carregar os corretores pelos quais este é responsável
         */
        managerHandler(value) {
            const broker = this.filters.findIndex(filter => filter.params.name === 'broker_id')
            this.filters[broker].options = []
            this.filters[broker].params.value = null

            /** Check if the event value is valid */
            const isValid = value && (typeof value === 'object' ? value.length : true)

            if (isValid) {
                const index = this.filters.findIndex(filter => filter.params.name === 'broker_id')
                team.getBrokersByManager(value)
                    .then(response => {
                        this.filters[index].options = response.data
                    })
                    .catch(this.handleApiError)
            }
        },
        showFunnel() {
            // this.oldPanelLinkButton('vendas/negocios/funil')
            this.$router.push({
				name: 'sales.deals.funnel',
			})
		},
        filterMaker(arr, prefix = '', sufix = '') {
            if (!arr) return
            return arr.map(e => `${prefix}${e}${sufix}`).join(',')
        },

        requisitionFiltersChagerd(label, newParams) {
            let filter = this.filters.find(item => item.label == label)
            this.requisitionChange(filter, newParams)
		},

		async requisitionFiltersPagination(label, search) {
            let filter = this.filters.find(item => item.label == label)
            /**
             *  verifica se foi feito uma pesquisa no search
             */
            if(!search.nextPage) {
                /**
                 * reseta os parametros para iniciar uma nova pesquisa
                 */
                filter.serviceParams[1].search = search.search
                filter.serviceParams[1].page = 1
                filter.options = []
                /**
                 * caso search veio vazia retorna os valores padrões 
                 */
                if(search.search == '') {
                    await this.requisitionChange(filter)
                    return
                }
            }
            
            await this.requisitionChange(filter)

        },

        requisitionChange(filter, newParams) {
            if((filter?.serviceParams?.[1] && filter.serviceParams[1].page > filter.lastPage) || filter.loading) return
            if ((filter && !filter.requestOnStart && !filter.alreadyRequested) || filter.lastPage) {
                (() => import('@/services/axios/modules/'+ filter.service + '.js'))().then(async service => {
                    await this.resolveFilter(filter, service, newParams)
                    if(label == 'Canal')this.channels.page = this.channels.page + 1
                    filter.alreadyRequested = label !== 'Canal'
                }).catch(this.handleApiError)
            }
        },

        async resolveFilter(filter, service, newParams) {
            filter.alreadyRequested = true
            const api = service.default.build()
            let params = ['']
            if (filter.serviceParams) params = newParams ? [ newParams ] : [...filter.serviceParams]

            filter.loading = true
            let request = await this.requestApi(api, filter, params)
            let data = request.data ? request.data : request
            if(data.error) {
                filter.loading = false
                return
            }
            /** Verifica se os resultados necessitam ser formatados */
            if (filter.parse) {
                filter.options = filter.options && filter.options.length > 0 ? filter.options.concat(filter.parse(data)) : filter.parse(data)
            } else {
                data.map(value => {
                    value.type = value.type == 'system' ? 'Sistêmica' : value.type == 'user' ? 'Usuário': value.type
                    filter.options.push(value)
                })
            }
            if(request.lastPage) this.loadPaginate(filter, request.lastPage)

            filter.loading = false
        },

        async requestApi(api, filter, params) {
            let data
            await api[filter.method](...params).then( response => {
                this.hasRequesting = false
                /** Verifica se a requisição retornou uma paginação */
                if (Object.prototype.hasOwnProperty.call(response.data, 'total')) {
                    data = {lastPage: response.data.last_page, data: [...response.data.data]}
                    /** Verifica se a requisição retornou um array */
                } else if (Object.prototype.hasOwnProperty.call(response.data, 'length')) {
                    data = [...response.data]

                /** Se nenhum dos outros casos for atendido, trata o retorno como um objeto */
                } else if (typeof response.data === 'object') {
                    data = { ...response.data }
                }
            }).catch(this.handleApiError)
            return data
        },
        loadPaginate(filter, lastPage) {
            this.filters.map(item => {
                if(item.label == filter.label) {

                    item.lastPage = lastPage
                    item.serviceParams[1].page++
                }
            })
        },
        handleApiError(error) {
            if (error.data && error.data.msg) {
                this.$toastr.e(error.data.msg);
            } else {
                this.$toastr.e(error);
            }
        },
        async fetchUsersWithPermissions() {
                    groups.getGroups()
            .then(({ data: groupsList }) => {
                const userLogged = JSON.parse(storage.get("user_logged")) || {}

              const matchedGroup = groupsList.find(g => g.name === userLogged.user_group);
            
              this.hasGroupPermissionToChangeOwner =
                matchedGroup?.permissions?.["funnel.deal.*.change.owner"] === 1;
            })
            .catch(error => {
              if (error.data && error.data.msg) {
                this.$toastr.e(error.data.msg);
              } else {
                this.$toastr.e(error);
              }
            });
        },


        handleCheckedItens(itens){
			this.checkedItens = itens;
			this.totalItens = itens.length;
        },

        openBulkModal() {
            if (this.valueSelect === 'alterar-etapa-status') {
                this.$root.$emit('modal-msg-open-change-stage-status-modal-bulk')
        
                this.$nextTick(() => {
                    this.valueSelect = null
                })
            }

            if (this.valueSelect === 'alteração-de-responsável') {
                this.$root.$emit('modal-msg-open-change-responsible-modal-bulk')
        
                this.$nextTick(() => {
                    this.valueSelect = null
                })
            }
        },
        // aqui inicia metodos da alteraçao em massa de responsáveis
        onBulkStepDataReceived({ stage, status }) {
            this.bulkStage = stage
            this.bulkStatus = status

            this.$root.$emit('modal-msg-open-bulk-step-modal')
        },

        onBulkStepClosed() {
             // Recarrega a listagem dos negócios
             this.$root.$emit('filter-list-deals')
        },

        //aqui inicia alteração em massa de responsáveis
        onBulkResponsibleStepDataReceived({ responsible, changeResponsibleCustomer  }) {
            this.bulkResponsible = {
                ...responsible,
                changeResponsibleCustomer
            };

            this.$root.$emit('modal-msg-open-bulk-responsible-step-modal')

        },
       
        // Método que constrói a seleção do botão de alteração em massa
        buildSelectMassAction() {
            // Sempre começa zerado
            this.selectMassAction = []

            if (this.hasPermissionToChangeStageInBulk) {
              this.selectMassAction.push({
                label: 'Alterar Etapa e Status',
                valueSelect: 'alterar-etapa-status'
              })
            }

            if (this.hasPermissionToChangeOwnerInBulk) {
              this.selectMassAction.push({
                label: 'Alteração de Responsável',
                valueSelect: 'alteração-de-responsável'
              })
            }
        }
    },
    
}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl';
</style>
